import { CardMember, DataSourcesTabsCard, NoDataInfo } from 'components'
import DataSourcesColumn from 'components/DataSourcesColumn'
import { Device } from 'components/Device'
import { useFamily } from 'context/hooks/useFamily'
import { cpfMask } from 'utils/masks'
import {
  decideIconSrcAtNoDataInfo,
  decideTitleAtNoDataInfo,
} from 'utils/utils'

import { formatMemberDesc } from 'utils/familyUtils'

import './styles.scss'
import React, { useState } from 'react'
import {
  type FamilyContextType,
  type FamilyMemberType,
} from 'types/services/Family'
import useQuery from 'context/hooks/useQuery'

function Members() {
  const device = Device.useDevice()
  const { families, inconsistencies, basesWithoutData, basesWithTimeout } =
    useFamily()
  const devicePrefix = device.prefix()

  const [currentBase, setCurrentBase] = useState(0)

  const { basesNamesList, basesIds } = useQuery()

  return (
    <main className={`container-members ${devicePrefix ?? 'undefined'}`}>
      <section className="container-members__content">
        <DataSourcesTabsCard
          titles={basesNamesList}
          currentBase={currentBase}
          setCurrentBase={setCurrentBase}
        >
          {families.map(({ base, family }: FamilyContextType) =>
            basesIds[currentBase] === base && family != null ? (
              <React.Fragment key={base}>
                <DataSourcesColumn key="Membros" title="Membros">
                  {family?.members.map((member: FamilyMemberType, i) => {
                    const listIsInconsistent =
                      inconsistencies?.childrenInconsistentFields?.[
                        `${member?.name?.replace(/ /g, '')?.toLowerCase()}`
                      ]
                    const isInconsistent =
                      listIsInconsistent?.some((value: string) =>
                        ['birthDate', 'gender'].includes(value)
                      ) ?? false
                    return (
                      <>
                        <CardMember
                          key={member.cpf}
                          title={member.name}
                          description={formatMemberDesc(member)}
                          cpf={cpfMask(member.cpf)}
                          familyHead={member.cpf === family.familyHead.cpf}
                          isInconsistent={isInconsistent}
                          listIsInconsistent={listIsInconsistent}
                        />
                      </>
                    )
                  })}
                </DataSourcesColumn>
              </React.Fragment>
            ) : (
              <div style={{ margin: '0 auto' }} key={base}>
                <NoDataInfo
                  iconSrc={decideIconSrcAtNoDataInfo(
                    basesWithoutData,
                    basesWithTimeout,
                    base
                  )}
                  title={decideTitleAtNoDataInfo(
                    basesWithoutData,
                    basesWithTimeout,
                    base,
                    'Membros'
                  )}
                  showIcon
                />
              </div>
            )
          )}
        </DataSourcesTabsCard>
      </section>
    </main>
  )
}

export default Members
